import React from "react";
import { parseString } from "xml2js";
import _ from "lodash";
import { Table, Button, Input, Segment } from "semantic-ui-react";
import api from "../../api";
import { ERR_MSG_SESSION_EXPIRED } from "../../ErrorMessages";
import settings from "../../settings";
import { expireSession, isTokenExpired } from "../../actions/auth";

class PricingDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      updatedReportCostRecs: [],
      userCode: undefined,
      loading: false,
    };
  }
  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (
      (nextProps.pickuser && nextProps.pickuser !== this.state.userCode) ||
      nextProps.user.userid !== this.state.userCode
    )
      this.loadData(nextProps);
  }

  loadData = (props) => {
    this.setState({ loading: true });
    const userCode =
      props.pickuser && props.pickuser !== ""
        ? props.pickuser
        : props.user.userid;
    const params = {
      view: "newcase",
      sserver: settings.appName,
      userID: props.user.userid,
      pickedUser: props.pickuser,
      sessionID: localStorage.getItem("sessionID"),
    };
    api.lp
      .getActivitiesView(params)
      .then((res) => {
        if (res) {
          parseString(res.data, { async: false }, (err, result) => {
            if (result !== null && result !== undefined) {
              const root = Object.keys(result)[0];
              if (root === "errors") {
                if (
                  _.get(result, `${root}.error[0].$.errType`) === "unauthorized"
                ) {
                  localStorage.errorMessage = _.get(
                    result,
                    `${root}.error[0].errMsg[0]`,
                    ""
                  );
                  this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
                }
              } else {
                const reports = _.get(
                  result,
                  "searchMenu.soap:Envelope[0].soap:Body[0].GetUserSearchListExResponse[0].GetUserSearchListExResult[0].UserItems[0].Reports[0].row"
                );
                const updatedReportCostRecs = this.state.updatedReportCostRecs;
                const updatedReports = [];
                _.forEach(reports, (report) => {
                  report.intReportId = parseInt(report.ReportID, 10);
                  updatedReportCostRecs[`rep_${report.intReportId}`] =
                    report.SearchResultCost[0];
                  updatedReports.push(report);
                });
                const orderedReports = _.orderBy(
                  updatedReports,
                  ["ReportTypeDescription[0]", "intReportId"],
                  ["asc", "asc"]
                );
                const folders = [];
                _.forEach(_.get(result, "searchMenu.folder"), (folder) => {
                  folders.push({
                    folderCode: parseInt(folder.folderCode, 10),
                    folderName: folder.folderName[0],
                    comment: folder.comment[0],
                    actUpdateFormatted: folder.actUpdateFormatted[0],
                    dateofentry: folder.dateofentry[0],
                  });
                });
                this.setState({
                  reports: orderedReports,
                  updatedReportCostRecs,
                  userCode,
                });
              }
            }
            this.setState({ loading: false });
          });
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.log("load case charges error - ", err);
        if (err.response && err.response.status === 401) {
          props.expireSession();
        }
      });
  };

  isCompMounted = false;

  reportCostChanged = (e, data, id) => {
    const updatedReportCostRecs = this.state.updatedReportCostRecs;
    updatedReportCostRecs[`rep_${id}`] = data.value;
    if (this.isCompMounted) {
      this.setState({ updatedReportCostRecs });
    }
  };

  submit = () => {
    const userCosts = [];
    _.forEach(Object.keys(this.state.updatedReportCostRecs), (repId) => {
      userCosts.push({
        reportId: repId.replace("rep_", ""),
        cost: this.state.updatedReportCostRecs[repId],
      });
    });
    if (isTokenExpired()) {
      expireSession(ERR_MSG_SESSION_EXPIRED);
      // return;
    }
    const userCode =
      this.props.pickuser && this.props.pickuser !== ""
        ? this.props.pickuser
        : this.props.userCode;
    api.lp
      .processUserCosts({
        userCode,
        userCosts,
      })
      .then((res) => {
        if (res.data.Status === "Error") {
          if (this.isCompMounted) {
            this.setState({ error: "Unable to save case" });
          }
        } else {
          this.props.removeUserCases();
          this.props.removeUserCaseCharges();
        }
      })
      .catch((err) => {
        console.log("Unable to process user cost request - ", err);
        if (err.response && err.response.status === 401) {
          this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
        }
      });
  };

  render() {
    const rows = [];
    const reports = this.state.reports;
    if (reports && reports.length > 0) {
      let prevReportTypeDescription;

      _.forEach(reports, (report, index) => {
        if (
          prevReportTypeDescription === undefined ||
          report.ReportTypeDescription[0] !== prevReportTypeDescription
        ) {
          rows.push(
            <Table.Row key={`case_rep_${index}_header`}>
              <Table.Cell colSpan={6} className="report-sub-section-header">
                {report.ReportTypeDescription[0].toUpperCase()}
              </Table.Cell>
            </Table.Row>
          );
          prevReportTypeDescription = report.ReportTypeDescription[0];
        }
        const userCost = _.get(report, "$.userCost");
        rows.push(
          <Table.Row key={`case_rep_${index}`}>
            <Table.Cell />
            <Table.Cell>{`${report.ReportLabel[0]} ${
              !report.ReportLabel[0].includes("Report") &&
              !report.ReportLabel[0].includes("Search")
                ? "Search"
                : ""
            } ${
              report.NumberAtCost[0] === 0
                ? `( first ${report.NumberAtCost[0]} )`
                : ""
            }`}</Table.Cell>
            <Table.Cell>{report.SearchResultCost[0]}</Table.Cell>
            <Table.Cell>{report.SearchNoResultCost[0]}</Table.Cell>
            <Table.Cell>
              <Input
                id={report.ReportID[0]}
                defaultValue={userCost || report.SearchResultCost[0]}
                onChange={(e, data) =>
                  this.reportCostChanged(e, data, report.ReportID[0])
                }
              />
            </Table.Cell>
          </Table.Row>
        );
      });
    }
    return (
      <Segment
        className="table-no-border box-shadow-none"
        loading={this.state.loading}
      >
        <Table>
          <Table.Body>
            <Table.Row className="report-section-header">
              <Table.HeaderCell width={2}>Type</Table.HeaderCell>
              <Table.HeaderCell width={6}>Service</Table.HeaderCell>
              <Table.HeaderCell width={3}>
                Service Charge - Hit
              </Table.HeaderCell>
              <Table.HeaderCell width={3}>
                Service Charge - No Hit
              </Table.HeaderCell>
              <Table.HeaderCell width={2}>My Charge</Table.HeaderCell>
            </Table.Row>
            {rows}
          </Table.Body>
        </Table>
        <Table className="table-no-border">
          <Table.Body>
            <Table.Row>
              <Table.Cell className={"float-right"}>
                <Button primary onClick={() => this.submit()}>
                  Submit
                </Button>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default PricingDetails;



// WEBPACK FOOTER //
// ./src/components/myaccount/PricingDetails.js